<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button type="primary" @click="$refs.form.show()">
            新增
          </Button>
          <c-bulk-delete
            :selected-items="listSelectedItems"
            @ok="confirmDelete"
          >
          </c-bulk-delete>
        </c-list-operations>
        <c-list-search>
          <Form
            class="c-form c-form--search"
            inline
            @submit.native.prevent="search"
          >
            <Form-item prop="name">
              <Input
                class="c-form__input"
                placeholder="请输入名称"
                v-model="cList.cSearch.where.name.$like"
              />
            </Form-item>
            <Form-item>
              <Button type="primary" @click="search">
                查询
              </Button>
            </Form-item>
          </Form>
        </c-list-search>
      </c-list-header>
    </c-list>
    <c-list-form ref="form" @get-list="getList"></c-list-form>
    <Modal width="434" footer-hide v-model="cQrCode.modal" title="报名二维码">
      <div class="b-qrcode-wrap">
        <img
          v-if="cQrCode.id"
          :src="
            `${this.$consts.SignInBaseUrl}/public/schools/${this.id}/classQrCodes/${cQrCode.id}`
          "
        />
        <a
          class="ivu-btn ivu-btn-primary"
          :href="
            `${this.$consts.SignInBaseUrl}/public/schools/${this.id}/classQrCodes/${cQrCode.id}?attachment=1`
          "
        >
          下载
        </a>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ListForm from "./form";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import Model from "@/models/admin/courses";

const module = "classes";
const initWhere = {
  name: {
    $like: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    "c-list-form": ListForm
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    const { ListColumnWidth, OrderAction } = this.$consts;

    return {
      id: 0,
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },
          {
            title: "名称",
            key: "name",
            minWidth: ListColumnWidth.Title
          },
          {
            title: "任课老师",
            width: 120,
            render: (h, { row }) => h("span", null, row.teacher.name)
          },
          {
            title: "上课地点",
            width: 180,
            render: (h, { row }) => h("span", null, row.address)
          },
          {
            title: "开班/结课时间",
            width: 200,
            render: (h, { row }) =>
              h(
                "span",
                null,
                row.startsAt && row.endsAt
                  ? `${row.startsAt} 至 ${row.endsAt}`
                  : ""
              )
          },
          {
            title: "操作",
            key: "action",
            width: 600,
            render: (h, { row }) =>
              h("div", [
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.$refs.form.show(row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.showQrCode(row.id);
                      }
                    }
                  },
                  "报名二维码"
                ),
                h(
                  "Button",
                  {
                    props: {
                      to: `/${this.alias}/classes/${row.id}/students`
                    }
                  },
                  "学员"
                ),
                h(
                  "Button",
                  {
                    props: {
                      to: `/${this.alias}/classes/${row.id}/courses`
                    }
                  },
                  "课程"
                ),
                h(
                  "Button",
                  {
                    props: {
                      to: `/${this.alias}/classes/${row.id}/courses/class-sign-ins`
                    }
                  },
                  "考勤"
                ),
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.export(row);
                      }
                    }
                  },
                  "点名表"
                ),
                h("c-dropdown", {
                  attrs: {
                    title: "排序",
                    options: OrderAction
                  },
                  on: {
                    click: action => {
                      this.order(row.id, action);
                    }
                  }
                }),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row.id);
                    }
                  }
                })
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  cQrCode = {
    id: 0,
    modal: false
  };

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.id = this.getSchoolId();
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  async export(row) {
    const data = await new Model().addPath("exportStudentSignIns").POST({
      body: {
        schoolId: this.id,
        classId: row.id
      }
    });

    console.log(data, "==");

    const courses = data.courses.filter(({ signIns }) => !!signIns);

    if (courses.length === 0) {
      this.$Message.error("暂无数据");
      return;
    }

    const students = courses[0].signIns.map(({ student }) => ({
      id: student.id,
      name: student.name
    }));

    console.log(students, "=");

    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet("点名表", {
      properties: { defaultRowHeight: 26, defaultColWidth: 14 }
    });

    worksheet.getCell("A1").value = "班级";
    worksheet.getCell("A1").style = {
      alignment: {
        vertical: "middle"
      }
    };

    worksheet.mergeCells("B1:D1");
    worksheet.getCell("B1:D1").style = {
      alignment: {
        vertical: "middle"
      }
    };
    worksheet.getCell("B1:D1").value = data.class.name;

    worksheet.getCell("A2").value = "教师";
    worksheet.getCell("A2").style = {
      alignment: {
        vertical: "middle"
      }
    };

    worksheet.mergeCells("B2:D2");
    worksheet.getCell("B2:D2").style = {
      alignment: {
        vertical: "middle"
      }
    };
    worksheet.getCell("B2:D2").value = data.class.teacher
      ? data.class.teacher.name
      : "";

    const dates = data.courses.map(({ date }) => date);

    worksheet.addRow(["学生姓名", ...dates]).alignment = {
      vertical: "middle"
    };

    students.forEach(student => {
      const types = dates.map(date => {
        const foundCourse = data.courses.find(course => course.date === date);

        const type =
          foundCourse.signIns &&
          foundCourse.signIns.find(signIn => signIn.student.id === student.id)
            ? foundCourse.signIns.find(
                signIn => signIn.student.id === student.id
              )["type"]
            : "";
        return (
          {
            Normal: "✓",
            Late: "迟到",
            Leave: "请假",
            Shift: "调课",
            Tiaoke: "调课"
          }[type] || "-"
        );
      });

      worksheet.addRow([student.name, ...types]).alignment = {
        vertical: "middle"
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    FileSaver.saveAs(blob, `${row.name}.xlsx`);
  }

  showQrCode(id) {
    this.cQrCode.modal = true;
    this.cQrCode.id = id;
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        include: [{ model: "Teacher", as: "teacher" }],
        where: this.listSearchWhere,
        order: [["order", "DESC"]]
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async order(id, action) {
    await this.$store.dispatch(`${module}/postAction`, {
      id,
      action: "order",
      query: {
        where: this.listSearchWhere || initWhere
      },
      body: { action }
    });

    this.$Message.success("排序成功");
    this.getList();
  }
}
</script>

<style lang="scss" src="./style.scss"></style>
